import styled, { css } from "styled-components";
import { ButtonContainer } from "../RegisterHost/RegisterHostStep/style";
import ButtonSmall from "../../../common/ButtonSmall";
import { mobile } from "../../../../utils/css/media";

export const Button = styled(ButtonSmall)`
  ${mobile(css`
    width: 13.1rem;
    height: 4.8rem;
  `)}
`;

export const GoBackBtn = styled.button`
  border: none;
  background: none;
  text-decoration: underline;
  font-family: HeeboRegular, sans-serif;
  font-size: 1.6rem;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
  cursor: pointer;
  vertical-align: sub;

  &:after {
    content: "";
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(135deg);
    --webkit-transform: rotate(135deg);
    margin-right: 0.5rem;
  }
`;

// @ts-ignore
export const ButtonsContainer = styled(ButtonContainer)`
  display: flex;
  justify-content: space-around;
  padding-left: 2rem;

  > button:first-of-type {
    width: 156px;
    font-weight: bold;
    font-size: 1.4rem;
    height: 4rem;
    margin-bottom: 2rem;
    margin-top: -0.5rem;
  }

  ${GoBackBtn} {
    padding-left: 1rem;
    font-weight: 400;
    margin-bottom: auto;
    margin-top: auto;
    font-size: 1.6rem;
  }
`;

// @ts-ignore
export const ImageContainer = styled(ButtonContainer)`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  margin-top:5px;
`;